export default "__VITE_ASSET__CBhYSh4H__"